import { BidTypes } from 'modules/domain/bid/types'
import { isPurchaseBid } from 'modules/domain/bid/utils'
import { refetchFunc } from 'modules/domain/common/hooks'
import { Deal } from 'modules/domain/deal/types'
import { FC, useState } from 'react'
import { Card } from 'views/components/Card/Card'
import { BuyerWarehouseEditModal } from 'views/components/WarehouseModal/BuyerWarehouseEditModal'
import { SellerWarehouseEditModal } from 'views/components/WarehouseModal/SellerWarehouseEditModal'
import { useAddress } from '../useAddress'
import { getDealBid } from 'modules/domain/deal/utils'

type Props = {
  deal: Deal
  bidType: BidTypes
  disabled?: boolean
  refetch: refetchFunc
}

export const WarehouseEditAction: FC<Props> = ({ disabled = false, refetch, deal, bidType }) => {
  const bid = getDealBid(deal, bidType)
  const isPurchase = isPurchaseBid(bid)
  const DealWarehouseEditModal = isPurchase ? BuyerWarehouseEditModal : SellerWarehouseEditModal

  const [modalVisible, setModalVisible] = useState(false)
  const [, , dealAddressRefetch] = useAddress(bid.owner.id, bid.address.id)

  const onAddressUpdate = async () => {
    await refetch()
    await dealAddressRefetch()
  }

  if (disabled) {
    return null
  }

  return (
    <>
      <Card.EditButton
        id={isPurchase ? 'editBuyerWarehouse' : 'editSellerWarehouse'}
        onClick={() => {
          setModalVisible(true)
        }}
      />
      {modalVisible && (
        <DealWarehouseEditModal
          onClose={() => setModalVisible(false)}
          bid={bid}
          onSuccess={onAddressUpdate}
          dealId={deal.id}
        />
      )}
    </>
  )
}
